import type { Theme } from "./theme";

export function ComparisonTable({ theme, rows }: { theme: Theme; rows: [string, string][] }) {
  return (
    <div
      style={{
        border: `1px solid ${theme.border}`,
        borderRadius: theme.radius * 1.5,
        background: theme.bg,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          padding: "16px 24px",
          borderBottom: `1px solid ${theme.border}`,
          background: theme.surface,
        }}
      >
        <div
          style={{
            fontSize: 12,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            color: theme.fgMute,
          }}
        >
          Agency-led hiring
        </div>
        <div
          style={{
            fontSize: 12,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            color: theme.accentFg,
            fontWeight: 500,
          }}
        >
          With Rarion
        </div>
      </div>
      {rows.map((r, i) => (
        <div
          key={r[0]}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            padding: "18px 24px",
            borderBottom: i < rows.length - 1 ? `1px solid ${theme.border}` : "none",
          }}
        >
          <div style={{ fontSize: 15, color: theme.fgMute }}>{r[0]}</div>
          <div style={{ fontSize: 15, color: theme.fg, fontWeight: 500 }}>{r[1]}</div>
        </div>
      ))}
    </div>
  );
}
